import { render, staticRenderFns } from "./macroTab2.vue?vue&type=template&id=6c93c4f6&scoped=true"
import script from "./macroTab2.vue?vue&type=script&lang=js"
export * from "./macroTab2.vue?vue&type=script&lang=js"
import style0 from "./macroTab2.vue?vue&type=style&index=0&id=6c93c4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c93c4f6",
  null
  
)

export default component.exports